import React from "react";

import { GoogleSignInButton } from "../auth/GoogleSignInButton";

/**
 * Gmail OAuth entry: branded Google button and optional small policy link.
 */
export function MailboxGoogleOAuthPanel({
  sectionTitle = null,
  onContinueToGoogle,
  disabled = false,
  loading = false,
  buttonText = "Continue with Google",
  buttonSize = "default",
  footerLink = null,
  className = "",
  buttonClassName = "",
}) {
  return (
    <div className={className}>
      {sectionTitle ? (
        <h2 className="font-display font-bold text-lg text-theme-on-background mb-3">{sectionTitle}</h2>
      ) : null}
      <GoogleSignInButton
        onClick={onContinueToGoogle}
        disabled={disabled}
        loading={loading}
        label={buttonText}
        size={buttonSize}
        className={buttonClassName}
      />
      {footerLink ? (
        <p className="mt-3 text-center font-mono text-[10px] text-theme-dim">
          <a
            href={footerLink.href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-theme-accent underline underline-offset-2 hover:opacity-90"
          >
            {footerLink.label}
          </a>
        </p>
      ) : null}
    </div>
  );
}
